import { render } from "./Inactivos.vue?vue&type=template&id=6af4f506"
import script from "./Inactivos.vue?vue&type=script&lang=js"
export * from "./Inactivos.vue?vue&type=script&lang=js"

import "./Inactivos.vue?vue&type=style&index=0&id=6af4f506&lang=scss"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__